import React, { useState } from 'react';
import { SzInput } from '@suezenv/react-theme-components';
import { GeoService } from "../../../../../services/geo-service";
import { GeographicalLatLng, IAddress, SearchAddressFilters } from "../../../../../type/Address.type";
import AutoComplete from "../../../../../form/autocomplete/autocomplete";
import { AUTOCOMPLETE_THRESHOLD } from "../../../../../constants/autocomplete";

interface AddressAutocompleteFilterProps {
    value: string;
    onChange: (value: any | null) => void;
    placeholder?: string;
    geographicalPriority?: GeographicalLatLng;
    searchAddressFilters?: SearchAddressFilters;
}

const AddressFilter: React.FC<AddressAutocompleteFilterProps> = ({
    value,
    onChange,
    placeholder,
    geographicalPriority,
    searchAddressFilters,
}) => {
    const [addressAutoComplete, setAddressAutoComplete] = useState<IAddress[]>([]); // Replace with actual suggestion type
    const [inputAddress, setInputAddress] = useState<string>(value);

    const isSearchTermValid = (): boolean => inputAddress.length >= AUTOCOMPLETE_THRESHOLD
   
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const address = event.target.value;
        setInputAddress(address);
        onChange(address);
        autoCompleteSearch(address);
    };

    const autoCompleteSearch = (value: string) => {
        if (isSearchTermValid()) {
            GeoService.searchAddress(value, geographicalPriority, searchAddressFilters)
                .then((autoCompleteList: IAddress[]) => {
                    setAddressAutoComplete(autoCompleteList);
                });
        } else {
            setAddressAutoComplete([]);
        }
    }

    const handleSuggestionClick = (index: number) => {
        onChange(addressAutoComplete[index]);
        setInputAddress(addressAutoComplete[index].address);
        setAddressAutoComplete([]);
    };

    return (
        <div className="address-autocomplete-filter position-relative">
            <SzInput
                value={inputAddress}
                onChange={handleInputChange}
                placeholder={placeholder}
                variant="outlined"
            />
            <AutoComplete
                items={addressAutoComplete.map((item: IAddress) => item.address)}
                onClickHandler={handleSuggestionClick}
                className="top-50"
            />
        </div>
    );
};

export default AddressFilter;